import NextLink from 'next/link';
import { type ComponentProps, forwardRef } from 'react';

// Next prefetches every link in the viewport by running its page's getServerSideProps in full: a page listing a
// hundred jobs cost a hundred uncached server renders and indexer searches per visit. Next still prefetches on hover.
export const Link = forwardRef<HTMLAnchorElement, ComponentProps<typeof NextLink>>(
  ({ prefetch = false, ...props }, ref) => <NextLink ref={ref} prefetch={prefetch} {...props} />,
);

Link.displayName = 'Link';
